var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"flex flex-1 items-center h-full hierarchy-item relative cursor-pointer min-w-0",class:{
    'cursor-not-allowed':
      (_vm.onlyLeafNodeSelectable && (_vm.node.children || []).length) ||
      _vm.node.disabled,
    active: _vm.selectedNodesId.indexOf(_vm.node.id) >= 0,
  },style:(_vm.style)},_vm.$listeners),[_c('MarkedContent',{key:_vm.node.id,ref:"markedRef",attrs:{"text":_vm.highlightTerm || ''}},[_c('div',{staticClass:"title-container flex flex-1 items-center min-w-0 h-full",class:{ 'with-bg': _vm.withBg },attrs:{"id":_vm.node.name}},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }